import script from "./PaymentCancelled.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentCancelled.vue?vue&type=script&setup=true&lang=js"

import "./PaymentCancelled.vue?vue&type=style&index=0&id=e31719ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e31719ea"]])

export default __exports__